class QuantityElement extends HTMLElement {
  constructor() {
    super();
    this.input = null;
    this.plusBtn = null;
    this.minusBtn = null;
    this.varId = null;
  }
  connectedCallback() {
    this.input = this.querySelector('.qty-value');
    this.plusBtn = this.querySelector('.qty-plus-btn');
    this.minusBtn = this.querySelector('.qty-minus-btn');
    this.varId = this.dataset.varid;
    this.plusBtn?.addEventListener('click', () => this.updateQuantity(1));
    this.minusBtn?.addEventListener('click', () => this.updateQuantity(-1));
  }
  updateQuantity(change) {
    let currentVal = parseInt(this.input.value) || 1;
    let newVal = currentVal + change;
    if (newVal <= 0) {
      const productCard = this.closest('.product-card');
      if (productCard) {
        const atcBtn = productCard.querySelector('.product-card__atc');
        if (atcBtn) atcBtn.style.display = 'block';
      }
      this.style.display = 'none';     
      this.updateCart(0);
      return;
    }
    this.input.value = newVal;
    this.updateCart(newVal);
  }
  updateCart(quantity) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [this.varId]: quantity
        }
      })
    })
      .then(response => response.json())
      .then(data => {
        this.updateCartCount();
        // if(quantity > 0){
        //   const cartDrawerButton = document.querySelector('.cart-drawer-button');
        //   if (cartDrawerButton) {
        //     cartDrawerButton.click();
        //   }
        // }
        // window.dispatchEvent(new CustomEvent('slidecart:refresh'));
      })
      .catch(error => {
        console.error('Cart update failed:', error);
      });
  }
  updateCartCount(){
    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count || 0;
      const countElement = document.querySelector('.cart-count');
 
      if (countElement) {
        countElement.textContent = count;
        // countElement.style.display = count > 0 ? 'inline-block' : 'none';
      }
    })
    .catch(err => console.error('Cart count update failed:', err));
  }
}
 
customElements.define('quantity-element', QuantityElement);
 
function setupSlidecartQuantityListener() {
  const shadowHost = document.querySelector('shadow-dom-container');
  const shadowRoot = shadowHost?.shadowRoot;
  if (!shadowRoot) return;
  const slidecartObserver = new MutationObserver(() => {
    const reduceBtns = shadowRoot.querySelectorAll('.reduce-quantity');
    const increaseBtns = shadowRoot.querySelectorAll('.increase-quantity');
    const removBtns = shadowRoot.querySelectorAll('.remove-btn');
 
    increaseBtns.forEach((btn)=>{
      if (!btn.hasAttribute('listener-attached')) {
        btn.addEventListener('click', () => {
          getAlldetails();
        });
        btn.setAttribute('listener-attached', 'true');
      }
    });
    removBtns.forEach((btn)=>{
      if (!btn.hasAttribute('listener-attached')) {
        btn.addEventListener('click', () => {
          getAlldetails();
        });
        btn.setAttribute('listener-attached', 'true');
      }
    });
   reduceBtns.forEach(btn => {
      if (!btn.hasAttribute('listener-attached')) {
        btn.addEventListener('click', () => {
          getAlldetails();
        });
        btn.setAttribute('listener-attached', 'true');
      }
    });
  });
  slidecartObserver.observe(shadowRoot, { childList: true, subtree: true });
}
 
setupSlidecartQuantityListener();
 
function getAlldetails(){
  const productCardAll = document.querySelectorAll('.product-card');
  const ProductCardBtn = document.querySelectorAll('.product-card__atc');
  const QuanityElemntsAll = document.querySelectorAll('.quanity_selector');
  QuanityElemntsAll.forEach((element) => {
    element.querySelector('quantity-element').style.display = 'none';
  });
  ProductCardBtn.forEach((btn) => {
    btn.style.display = 'block';
  });
  setTimeout(()=>{
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        cart.items.forEach(item => {
          const varId = item.variant_id.toString();
          const qty = item.quantity;
 
          const qtyEl = document.querySelectorAll(`quantity-element[data-varid="${varId}"]`);
          if (qtyEl) {
            qtyEl.forEach((item)=>{
               item.style.display = 'flex';
            const input = item.querySelector('.qty-value');
            if (input) input.value = qty;
 
            const productCard = item.closest('.product-card');
            if (productCard) {
              const atcBtn = productCard.querySelector('.product-card__action-button');
              if (atcBtn) atcBtn.style.display = 'none';
            }
            })
           
          }
        });
      });
  },1e3);
 
}


const CustomFilters  = localStorage.getItem('custom-filters')?.split(',');
if(CustomFilters == 0 || CustomFilters == "0" || CustomFilters == null){
  const ProductCards = document.querySelectorAll('.product-card');
       ProductCards.forEach((card)=>{
        card.parentElement.style.display = 'block';
       });
}
else if(CustomFilters !== 0 || CustomFilters !== '0' || CustomFilters !== null){
  for(var i=0; i<CustomFilters.length; i++){
    const customValue = CustomFilters[i].toLowerCase().replaceAll(' ','-');
    const bundleLink = document.querySelector(`[data-tag="${customValue}"]`);
    bundleLink.classList.add('active');
    // localStorage.setItem('custom-filters',this.textContent);
    // const data_tag = this.getAttribute('data-tag');
    // console.log("data_tag>>",data_tag)
  }
   const ProductCards = document.querySelectorAll('.product-card');
   const customFilterValues = localStorage.getItem('custom-filters')?.toLowerCase().split(',') || [];
    ProductCards.forEach((card)=>{
      const tags = card.getAttribute('data-tag')?.toLowerCase().split(',') || [];
      const isMatch = customFilterValues.some(filter => tags.includes(filter));
      card.parentElement.style.display = isMatch ? 'block' : 'none';
    })
}
let valueAdditon = [];
let dataTags = [];
document.querySelectorAll('.filter-custom-btn').forEach((custom_btn)=>{
  custom_btn.addEventListener('click',function(){
    const data_tag = this.getAttribute('data-tag');
    if(this.classList.contains('active')){
      this.classList.remove('active');
    const clickedValue = this.textContent.trim().toLowerCase(); 
    const index = valueAdditon.findIndex(val => val.toLowerCase() === clickedValue);
    if (index !== -1) {
      valueAdditon.splice(index, 1);
    }
     const newindex = dataTags.findIndex(val => val === data_tag);
    if (newindex !== -1) {
      dataTags.splice(index, 1);
    }
    const ProductCards = document.querySelectorAll('.product-card');
      localStorage.setItem('custom-filters',valueAdditon);
      setTimeout(()=>{
      if(valueAdditon.length !== 0){
        const customFilterValues = localStorage.getItem('custom-filters')?.toLowerCase().split(',') || [];
        ProductCards.forEach((card)=>{
        const tags = card.getAttribute('data-tag')?.toLowerCase().split(',') || [];
        const isMatch = customFilterValues.some(filter => tags.includes(filter));
        card.parentElement.style.display = isMatch ? 'block' : 'none';
      
        })
      }
      else{
         ProductCards.forEach((card)=>{
          card.parentElement.style.display = 'block';
          custom_btn.classList.remove('active');
         });
      }
      },1e3);
    }else{
      this.classList.add('active');
      valueAdditon.push(this.textContent);
      localStorage.setItem('custom-filters',valueAdditon);
      dataTags.push(data_tag);
      const ProductCards = document.querySelectorAll('.product-card');
      const customFilterValues = localStorage.getItem('custom-filters')?.toLowerCase().split(',') || [];
      ProductCards.forEach((card)=>{
      const tags = card.getAttribute('data-tag')?.toLowerCase().split(',') || [];
      const isMatch = customFilterValues.some(filter => tags.includes(filter));
      card.parentElement.style.display = isMatch ? 'block' : 'none';
    })
  }
  });
})
if (document.body.classList.contains('collection-new-design')){

  //Handle Filter Drawer and and Header Hight for New Collection Design 
  const header_announcement = document.querySelector(".collection-new-design .header_sticky").offsetHeight;
  const header = document.querySelector(".collection-new-design .shopify-section-group-header-group.header-section");
  let facet_drawer = document.querySelector(".collection-new-design drawer-component#FacetDrawer"); //To get Filter Drawer
  const facetDrawer = document.querySelector('#FacetDrawer .drawer__inner');
  const facet_form = document.querySelector('#FacetDrawer .face-form');
  const header_height = header.offsetHeight;
  if (window.innerWidth <= 768) {
    document.querySelector(".collection-new-design .collection_sticky").style.top = header_height + 'px';
    facet_drawer.classList.replace("drawer--left","drawer--bottom"); 
    const totalHeight = `calc(100vh - ${header_announcement}px - 80px)`;
    facet_form.style.height = totalHeight;
  }
  else{
    document.querySelector(".collection-new-design .collection_sticky").style.top = header_announcement + 'px';
  facetDrawer.style.top = header_announcement + 'px';
  const totalHeight = `calc(100vh - ${header_announcement}px - 160px)`;
  facet_form.style.height = totalHeight;
}
//End Handle Filter Drawer and and Header Hight for New Collection Design 
//Announcement Bar Sticky Change
window.addEventListener('scroll',function(){
  if(window.innerWidth < 768){
    if (window.scrollY > 0) {
        document.querySelector('.collection-new-design sticky-header').classList.remove('header_sticky');
        document.querySelector('.collection-new-design header').classList.add('header__sticky');
      } else {
        document.querySelector('.collection-new-design sticky-header').classList.add('header_sticky');
        document.querySelector('.collection-new-design header').classList.remove('header__sticky');
      }
  }
  else{
    document.querySelector('.collection-new-design sticky-header').classList.add('header_sticky');
    document.querySelector('.collection-new-design header').classList.remove('header__sticky');
  }
})
}


//////////////// birthday reward event ////////////////

// (function() {
//     const IFRAME_ID = 'iframe-kp';
//     const BUTTON_ID = 'submit-button';

//     // 1. Function to attach the listener once the iframe is loaded
//     function attachListenerToIframeContent(iframeElement) {
//         // Wait for the iframe content to fully load
//         iframeElement.onload = function() {
//             try {
//                 // Get the document context of the iframe
//                 const iframeDocument = iframeElement.contentWindow.document;
                
//                 // Now, search for the button inside the iframe's document
//                 const submitButton = iframeDocument.getElementById(BUTTON_ID);

//                 if (submitButton) {
//                     console.log(' Button found inside the iframe:', submitButton);
                    
//                     submitButton.addEventListener('click', (event) => {
//                         console.log('Button inside iframe clicked successfully!');
//                         // Your custom logic here
//                     });
//                 } 
//             } catch (e) {
//                 // This catches potential "Cross-Origin" errors, 
//                 // but usually not an issue if the iframe is on the same domain/app.
//                 console.error("Error accessing iframe content (might be due to cross-origin restriction):", e);
//             }
//         };

//         // If the iframe is already loaded by the time we attach 'onload', 
//         // manually call the load logic after a brief timeout.
//         if (iframeElement.contentWindow && iframeElement.contentWindow.document.readyState === 'complete') {
//              setTimeout(iframeElement.onload, 100);
//         }
//     }


//     // 2. Observer to detect when the iframe element is added to the DOM
//     const observer = new MutationObserver((mutationsList, currentObserver) => {
//         const iframe = document.getElementById(IFRAME_ID);

//         if (iframe) {
//             console.log('Iframe element found. Attaching content listener.');
            
//             // Stop observing the main document
//             currentObserver.disconnect();
            
//             // Proceed to the next step: wait for iframe content to load
//             attachListenerToIframeContent(iframe);
//         }
//     });

//     // Start observing the body for changes
//     observer.observe(document.body, { childList: true, subtree: true });

// })();

